<template>
  <div>
    <div class="form">
      <table width="100%">
        <tr>
          <td width="85"><span class="redstar">*</span>姓名：</td>
          <td>
            <input type="text" class="input" v-model="comment.name" />
          </td>
        </tr>
        <tr>
          <td><span class="redstar">*</span>邮箱：</td>
          <td>
            <input type="text" class="input" v-model="comment.email" />
          </td>
        </tr>
        <tr v-if="id== 746">
          <td><span class="redstar">*</span>主题：</td>
          <td>
            <input type="text" class="input" v-model="comment.title" />
          </td>
        </tr>
        <tr>
          <td><span class="redstar">*</span>内容：</td>
          <td>
                    <textarea
                        style="border: 1px solid #d8eaff; background: #f5f5f6"
                        cols="60"
                        rows="10"
                        v-model="comment.content"
                        maxlength="200"
                    ></textarea>
                    <span style="color:red"> 限制内容输入200个字符</span>
          </td>
        </tr>
        <tr >
          <td><span class="redstar">*</span>移动电话：</td>
          <td style="display: flex; width: 100%;">
            <input
                type="number"
                class="input"
                v-model="comment.telephone"
                @blur="blurTest"
            />

            <span style="color: red">{{blurTest() ? '': '* 手机号格式不正确'}}</span>
          </td>
        </tr>
        <tr>
          <td width="85"><span class="redstar">*</span>验证码：</td>
          <td style="display: flex; width: 100%;">
            <input type="text" class="input" v-model="comment.code" />
            <div class="fs"  size="mini"  @click="startCountdown" :disabled="isCountingDown">
              {{ buttonText }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <button type="button" class="btn" @click="send">
              发送
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {checkCode} from "@/network/api";

export default ({
  name: "feedback",
  props:{
    id:{
      type:[String,Number],
      default:0
    },
  },
  data() {
    return {
      comment:{
        "name": "",
        "telephone": "",
        "email": "",
        // "title": "",
        "content": "",
        "phone":"",
        "code":'',
      },
      uuid:"",
      isCountingDown: false,
      remainingSeconds: 0,
      countdownTimer: null,
    }
  },
  computed: {
    buttonText() {
      if (this.isCountingDown) {
        return `${this.remainingSeconds} 秒后重新获取`;
      } else {
        return '获取验证码';
      }
    },
  },
  methods:{
     send(){
      if(!this.comment.name){
         return  this.$message.error('请先输入姓名');
      }
      if(!this.comment.email){
        return this.$message.error('请先输入邮箱');
      }
      if(!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.comment.email)){
        return this.$message.error('邮箱格式不正确');
      }
      if(!this.comment.title && this.id == 746){
        return this.$message.error('请先输入主题');
      }
      if(!this.comment.telephone){
        return this.$message.error('请先输入手机号码');
      }
      if( !/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(this.comment.telephone)){
        return this.$message.error('手机号码格式不正确');
      }
      if(!this.comment.code){
        return this.$message.error('请先输入验证码');
      }
      let data = {
        uuid:this.uuid,
        phone:this.comment.telephone,
        code:this.comment.code,
      }
      this.$api.checkCode(data).then(async  ess => {
        if(ess.data.code == 200){
          let res = await this.$api.create(this.comment);
          if(res.data.code == 200){
            this.$message({
              message: '留言成功',
              type: 'success'
            });
            for(let item in this.comment){
              this.comment[item] = ""
            }
            this.stopCountdown();
          }else{
            this.$message.error(res.data.msg);
          }
        }else{
          return this.$message.error(ess.data.msg)
        }
      })
    },
    blurTest(){
      if(!this.comment.telephone){
        return true;
      }
      return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(this.comment.telephone)
    },
    startCountdown() {

      if (this.comment.telephone == '') {
        return this.$message.error('请输入手机号码')
      }
      const regex = /^1[3456789]\d{9}$/
      if (!regex.test(this.comment.telephone)) {
        return this.$message.error('手机号码格式错误')
      }
      if (this.isCountingDown) {
        return;
      }

      let data = {
        phone: this.comment.telephone,
        timeOut: 60,
        smsmode:2 //忘记密码
      }
      this.isCountingDown = true
      this.$api.sendMsg(data).then(res => {
        if(res.data.code  == 200){
          this.uuid = res.data.data.uuid;
          this.isCountingDown = true;
          this.remainingSeconds = 60;

          this.countdownTimer = setInterval(() => {
            this.remainingSeconds--;

            if (this.remainingSeconds <= 0) {
              this.stopCountdown();
            }
          }, 1000);
        }else{
          this.stopCountdown();
          return this.$message.error(res.data.msg)
        }

      }).catch(error => {
        this.isCountingDown = false;
        console.error('Failed to request verification code:', error);
      })

    },
    stopCountdown() {
      clearInterval(this.countdownTimer);
      this.isCountingDown = false;
      this.remainingSeconds = 0;
    },
  }
})
</script>

<style scoped>
.fs{
  font-size: 14px;
  width: 125px;
  height: 30px;
  border-radius: 34px;
  background: #244991;
  color: #fff;
  margin-left: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
</style>
